import { Injectable } from '@angular/core';
import {
  AuthService,
  AuthStatePersistenceService,
  createFrom,
  EventService,
  Product,
  ProductService,
} from '@spartacus/core';
import { NavigationEvent } from '@spartacus/storefront';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { Ga4GgProductPageEvent } from './ga4-gg-product-page-event';

@Injectable({
  providedIn: 'root',
})
export class Ga4GgProductPageEventBuilder {
  constructor(
    private eventService: EventService,
    private productService: ProductService,
    private authService: AuthService,
    private authStatePersistenceService: AuthStatePersistenceService
  ) {
    const ga4GgProductPageCleanUpEventSource = this.eventService.get(NavigationEvent).pipe(
      filter((navigationEvent) => navigationEvent.semanticRoute === 'product'),
      switchMap((navigationEvent) =>
        this.productService.get(navigationEvent.context.id).pipe(
          filter((product) => Boolean(product)),
          take(1),
          map((product) =>
            createFrom(Ga4GgProductPageEvent, {
              ecommerce: null,
            })
          )
        )
      )
    );

    eventService.register(Ga4GgProductPageEvent, ga4GgProductPageCleanUpEventSource);

    const ga4GgProductPageEventSource = this.eventService.get(NavigationEvent).pipe(
      filter((navigationEvent) => navigationEvent.semanticRoute === 'product'),
      switchMap((navigationEvent) =>
        this.productService.get(navigationEvent.context.id).pipe(
          filter((product) => Boolean(product)),
          take(1),
          map((product) =>
            createFrom(Ga4GgProductPageEvent, {
              event: 'view_item',
              visitor_type: authStatePersistenceService.isUserLoggedIn() ? 'logged_in' : 'logged-out',
              ecommerce: {
                currency: product?.price?.currencyIso,
                value: product?.price?.value,
                items: product ? this.getItemFromProduct(product) : undefined,
              },
            })
          )
        )
      )
    );

    eventService.register(Ga4GgProductPageEvent, ga4GgProductPageEventSource);
  }

  private getItemFromProduct(product: Product) {
    const items: {
      item_id?: string;
      item_name?: string;
      item_list_name?: string;
      price?: number;
      quantity?: number;
    }[] = [];

    const item = {
      item_id: product.code,
      item_name: product.modelMark,
      item_list_name: 'Category',
      price: product.price?.value,
      quantity: 1,
    };

    product.categoryHierarchy?.forEach((category, index) => {
      item['item_category' + (index.toString() !== '0' ? (index + 1).toString() : '')] = category.name;
    });

    Object.keys(item).forEach((key) => (item[key] === undefined ? delete item[key] : {}));

    items.push(item);

    return items;
  }
}
